<template lang="pug">
Row.curation
  Column.image-col(tablet="6" mobile="12")
    .curation-main-image(
      ref="image"
      :style="{ 'background-image': 'url(' + image + ')' }"
    )
  Column.curation-content(tablet="6" mobile="12")
    .close(@click="$emit('close')")
      Icon(name="x" fill="#000")
    .curation-profile
      StaticImage.curation-avatar(
        v-if="author.image"
        :src="author.image"
        :width="100"
        :alt="author.username"
        lazy
      )
      a.curation-meta(target="_blank" rel="noopener noreferrer" :href="permalink")
        .curation-alias {{author.username}}
        .second-line
          .curation-date {{ date }}
          Icon(name="instagram" fill="black")
    .content-scroll.custom-scroll
      .curation-text {{ text }}
      .featured-products.custom-scroll(v-if="products.length > 0")
        b.heading {{ __('Featured Products') }}
        .products-grid
          a.product(v-for="product in products" :key="product.id" @click.prevent="pushToProductPage(product.link)" href="#")
            .product-info
              img(:src="product.images[0].smallSquare.link" :alt="`${product.name} image`")
              b {{ __(product.name) }}
            RogueButton.shop-btn(size="s" color="red" @click.stop="pushToProductPage(product.link)") {{ __('Shop Now') }}
    .bottom
      slot
</template>
<script>

export default {
  name  : 'curation',
  props : {
    author: {
      type    : Object,
      default : () => ({}),
    },
    date: {
      type    : String,
      default : undefined,
    },
    image: {
      type    : String,
      default : undefined,
    },
    text: {
      type    : String,
      default : '',
    },
    permalink: {
      type    : String,
      default : '',
    },
    products: {
      type    : Array,
      default : () => ([]),
    },
  },
  emits   : ['close'],
  methods : {
    async pushToProductPage(link) {
      // Make sure link is always an absolute URL
      if (link.indexOf('http') !== 0) {
        link = `https://www.roguefitness.com${link}`
      }

      const store = this.$rogue.site.code
      try {
        const url = new URL(link)
        let path = url.pathname
        if (store !== 'USA') {
          // Force it to load the USA route
          const resp = await this.$rogue.fetch(`/svc_route/route/?url=${url.pathname}`, 'GET', {}, {
            'rg-site': 'www.roguefitness.com',
          })
          const relatedUrl = resp.related?.[this.$rogue.site.key]

          // There is no URL for this product on this store
          if (!relatedUrl) {
            window.location = link
          }

          path = relatedUrl
        }
        await this.$rogue.router.push(path)
      } catch (e) {
        console.log(e)
        this.$rogue.log.info(`Unable to reroute to product with link: ${link}`, e)
        window.location = link
      }
    },
  },
}

</script>
<style lang="scss" scoped>
  .close {
    right: 10px;
    position: absolute;
    cursor: pointer;
  }

  .curation-main-image {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    background-color: $color-black;
    width: 100%;
    height: 100%;
    padding-top: 100%;
  }

  @media (max-width: $tablet) {
    .curation-main-image {
      padding-top: 100%;
      background-size: 100%;
    }
  }

  .curation-profile {
    display: flex;
    align-items: center;
  }

  .curation-content {
    position: relative;
    padding: $space-s;
  }

  .curation-meta {
    text-decoration: none;

    .curation-alias {
      color: $color-black;
    }

    &:hover {
      .curation-alias {
        text-decoration: underline;
      }
    }

    .second-line {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }

    .curation-date {
      color: $color-gray-dark;
      margin-top: $space-xxxs;
      margin-right: $space-xxxs;
      font-size: $size-xs;
    }
  }

  .content-scroll {
    margin-top: $space-m;

    @include mobile {
      .modal-scroll &.custom-scroll {
        // calculation for the height of the image and other elements in each modal slide
        max-height: calc(90vh - (90vw - 80px) - 140px);
        overflow: auto;
      }
    }
  }

  .curation-text {
    white-space: normal;
  }

  .featured-products {
    margin-top: $space-xs;
    border-top: 1px solid $color-gray;
    padding-top: $space-xs;

    @media (min-width: $tablet) {
      .modal-scroll &.custom-scroll {
          max-height: 330px;
          overflow: auto;
      }
    }

    .heading {
      display: block;
      margin-bottom: $space-s;
    }

    .products-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: 1fr;
      gap: 20px;

      .product {
        color: $color-black;
        text-decoration: none;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;

        img {
          width: 100%;
        }

        .shop-btn {
          margin-top: $space-m;
          align-self: center;
        }
      }
    }
  }

  .bottom {
    :deep(.sharing-buttons) {
      justify-content: flex-start;
      margin-bottom: 0;
    }
  }

  .image-col {
    padding: 0;
    display: flex;
    align-self: stretch;
  }

  .curation-avatar {
    width: 50px;
    height: 50px;
    border-radius: $radius-circle;
    overflow: hidden;
    margin-right: $space-xxs;
  }

  .roguebox-curation-slide {
    width: 100%;
    max-width: calc(90vw - 80px);
    max-height: 90vh;
    background: $color-white;
    overflow: auto;

    :deep(.row) {
      margin: 0;
    }

    @include all-desktop() {
      max-width: 800px;
    }
  }
</style>
